import axios, { AxiosInstance } from "axios";

const instance: AxiosInstance = axios.create({});
export default instance;
